// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_SITE_BY_ID_REQUEST_SUCCESS,
  GET_SITE_BY_ID_REQUEST_ERROR,
  GET_SITE_BY_ID_REQUEST,
} from "../../constants";
import axios from "../../../../services/api";

function* getSiteByIdRequest(data) {
  try {
    const response = yield call(axios.get, `/sites/?id=${data.id}`);
    if (response.data.error) {
      yield put({
        type: GET_SITE_BY_ID_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_SITE_BY_ID_REQUEST_SUCCESS,
        data: response.data.results,
      });
    }
  } catch (error) {
    yield put({
      type: GET_SITE_BY_ID_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* getSiteByIdRequestSaga() {
  yield takeLatest(GET_SITE_BY_ID_REQUEST, getSiteByIdRequest);
}
